module.exports = __webpack_public_path__ + "img/analytics_telemetry_no_data.4ca294ef.png";